import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { ImagePlus } from 'lucide-react';
import { resolveImageUrl } from '../../lib/imageCache';

const API = process.env.REACT_APP_BACKEND_URL;

export const roomToScene = (room) => ({
  id: `saved-${room.id}`, savedId: room.id, name: room.name, icon: ImagePlus, editable: true,
  aspect: room.aspect, images: { day: resolveImageUrl(room.image_url, 1024) }, shades: [{ label: 'Your Window', quad: room.quad }],
});

/* Saved rooms for the signed-in customer (object storage + user_rooms collection) */
export const useSavedRooms = (token) => {
  const [rooms, setRooms] = useState([]);
  const headers = token ? { Authorization: `Bearer ${token}` } : {};

  useEffect(() => {
    if (!token) { setRooms([]); return; }
    axios.get(`${API}/api/user/rooms`, { headers }).then(({ data }) => setRooms(data)).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const save = useCallback(async (blobUrl, quad, name) => {
    const blob = await (await fetch(blobUrl)).blob();
    const form = new FormData();
    form.append('file', blob, 'room.jpg');
    form.append('name', name);
    form.append('quad', JSON.stringify(quad));
    const { data } = await axios.post(`${API}/api/user/rooms`, form, { headers });
    setRooms(r => [data, ...r]);
    return data;
  }, [headers]);

  const update = useCallback(async (id, patch) => {
    await axios.put(`${API}/api/user/rooms/${id}`, patch, { headers });
    setRooms(r => r.map(x => (x.id === id ? { ...x, ...patch } : x)));
  }, [headers]);

  const remove = useCallback(async (id) => {
    await axios.delete(`${API}/api/user/rooms/${id}`, { headers });
    setRooms(r => r.filter(x => x.id !== id));
  }, [headers]);

  return { rooms, save, update, remove };
};
